import {
  GET_VESSEL_TRACKING,
} from 'src/api/routes';

import { API_BASE_URL } from 'src/globals';
import { GET } from 'src/api/apiHandler';

export const getVesselTracking = async (params) => {
  return GET(`${API_BASE_URL}${GET_VESSEL_TRACKING}`, params);
}